import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { HistoryPageComponent } from './history.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: HistoryPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class HistpryPageRoutingModule {}
